import type { Theme } from '@mui/material/styles';

// Brighter pink reads better on dark glass; light mode uses the theme's deeper pink.
export const pinkLink = (theme: Theme) =>
  theme.palette.mode === 'dark' ? '#ff4fa3' : theme.palette.primary.main;
